import { toPost } from "../../../../../../../common/apis/http-utils";
import { AdvertisementItem, FetchField, AdvertisementDetail } from "../types";

export const formatListResult = (result: any): any => {
    console.log("formatListResult", result);
    const mergeResult = result;
    return {
        list: mergeResult.data,
        total: mergeResult.total,
    };
};

export const merchantLiveAdList = toPost<
    FetchField.MerchantLiveAdList,
    AdvertisementItem[]
>(`/merchant/live/adList`);

export const merchantLiveAdStore = toPost<FetchField.MerchantLiveAdStore, any>(
    "/merchant/live/adStore"
);

export const merchantLiveAdUpdate = toPost<
    FetchField.MerchantLiveAdStoreEdit,
    any
>("/merchant/live/adUpdate");

export const merchantLiveAdSet = toPost<{ id: string }, any>(
    "/merchant/live/adSet"
);

export const merchantLiveAdShow = toPost<
    FetchField.MerchantLiveAdShow,
    AdvertisementDetail
>("/merchant/live/adShow");

export const merchantLiveAdDestroy = toPost<
    FetchField.MerchantLiveAdShow,
    AdvertisementDetail
>("/merchant/live/adDestroy");